import React from "react";
import image2 from "../../images/WW-Hero-1.jpg";
import { Helmet } from "react-helmet";

import styles from "./index.module.css";

export default function InvestmentrequirementsPage() {
	return (
		<div className={styles.InvestmentrequirementsPage}>
			<Helmet>
				<title>Wet Willie's Franchise | Investment Requirements</title>
			</Helmet>
			<div className={styles.figureContainer}>
				<figure>
					<img src={image2} alt="" />
				</figure>
			</div>
			<div className={styles.header}>
				<h1>REQUIREMENTS</h1>
			</div>
			<div className={styles.articleContainer}>
				<article>
					<section className={styles.section2}>
						<h2>Franchisee requirements:</h2>
						<ul>
							<li>
								<span>•</span>Net worth of a minimum $1,000,000
							</li>
							<li>
								<span>•</span>
								Liquid assets (assets that can be easily
								converted to cash) of $500,000
							</li>
							<li>
								<span>•</span>
								No more than 80% of the start-up costs can be
								borrowed
							</li>
							<li>
								<span>•</span>
								Ability to attend an 8 week on-site training
								program that will include weekends
							</li>
							<li>
								<span>•</span>
								Must be an active participant in the operation
								of your business
							</li>
						</ul>

						<h2>Franchise Fees and Royalties:</h2>
						<ul>
							<li>
								<span>•</span>
								Single unit franchise fee of $35,000 is due upon
								signing of franchise agreement
							</li>
							<li>
								<span>•</span>Royalty rate of 5% based on weekly
								sales
							</li>
							<li>
								<span>•</span>
								Required Local Advertising Expenditures of 2% of
								annual gross sales
							</li>
							<li>
								<span>•</span>
								Contribution to Wet Willie's "National Brand
								Fund", 1.5% based on weekly gross sales
							</li>
						</ul>

						<h2>Requirements and Costs Statement:</h2>
						<br />
						<p>
							Your Initial Investment can vary depending on your
							geographic location, your chosen location and
							condition of your franchise, your choices in design
							and construction, your rent, other fees related to
							licensing and permitting, and miscellaneous factors.
							In our experience, the initial investment required
							to startup a Wet Willie's ranges from $721,500 to $1,643,000. These costs may vary and include the
							franchise fee, cost of furniture, fixtures, and
							equipment, leasehold improvements, initial
							inventory, pre-opening advertising and other
							expenses.
						</p>
						<br />
						<p>
							While we do allow financing of your Wet Willie's
							franchise location, we require you finance no more
							than 80% of those costs. We also require you to have
							sufficient working capital to maintain your
							franchise business for at least 90 days once your
							location has opened. Failure to maintain sufficient
							working capital throughout the life of your
							franchise is a material breach of your franchise
							agreement and will put your franchise business at
							risk.
						</p>
					</section>
				</article>
			</div>
		</div>
	);
}
